import locationGoogleMaps from './google-maps';

/* eslint no-param-reassign: "error" */
function toggleClass(el, className) {
  if (el.classList) el.classList.toggle(className);
  if (el.classList.contains(className)) locationGoogleMaps();
}

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
}

const eventHandler = () => {
  const body = document.querySelector('body');
  const opener = document.querySelector('.js-mobile-map-opener');
  if (opener)
    opener.addEventListener('click', () => {
      toggleClass(body, 'isMobileMapOpen');
    });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 800) {
      removeClass(body, 'isMobileMapOpen');
    }
  });
};

const mobileMapOpener = async () => {
  eventHandler();
};

export default mobileMapOpener;
